import { Pipe, PipeTransform } from '@angular/core';

import { getClientUserRoleLabel } from '@zerops/models/client-user';

// Delegates to getClientUserRoleLabel so the role -> label mapping has a single
// definition; this pipe used to carry its own copy.
@Pipe({
  name: 'roleTranslate',
  pure: true,
  standalone: true
})
export class RoleTranslatePipe implements PipeTransform {
  transform(role: string, canCreateProjects?: boolean): string {
    return getClientUserRoleLabel(role, canCreateProjects);
  }
}
